import { createPageElement } from "@insite/client-framework/Components/ContentItemStore";
import { HasShellContext, ShellContext, withIsInShell } from "@insite/client-framework/Components/IsInShell";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { loadPageByType } from "@insite/client-framework/Store/Data/Pages/PagesActionCreators";
import { getPageStateByType } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { nullPage } from "@insite/client-framework/Store/Data/Pages/PagesState";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";

const mapStateToProps = (state: ApplicationState) => {
    const globalElementsPageState = getPageStateByType(state, "GlobalElementsPage");
    return {
        globalElementsPage: globalElementsPageState.value || nullPage,
        isLoading: globalElementsPageState.isLoading,
    };
};

const mapDispatchToProps = {
    loadPageByType,
};

type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & HasShellContext;

class GlobalElementsPage extends React.Component<Props> {
    componentDidMount() {
        const props = this.props;
        if (!props.isLoading && props.globalElementsPage.id === "") {
            props.loadPageByType("GlobalElementsPage");
        }
    }

    render() {
        const {
            globalElementsPage,
            shellContext: { isInShell },
        } = this.props;
        if (globalElementsPage.id === "") {
            return null;
        }

        return (
            <ShellContext.Provider value={{ isInShell, pageId: globalElementsPage.id }}>
                {createPageElement(globalElementsPage.type, globalElementsPage)}
            </ShellContext.Provider>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withIsInShell(GlobalElementsPage) as any);
